import { S6Request } from "components/request/request";
import sislogUserGlobals from "components/UserGlobals";
import "datatables.net";
import * as queryString from "lib/queryString/queryString";
import { ScrollPosition } from "./scrollPosition";
import { TableData } from "./table";
import { TableModel } from "./tableModel";

export class Paginator {
    /**
     * A reference to the model array in the table.
     */
    private model: TableModel;
    private url: string;
    private currentSorting: AjaxDataRequestOrder[] = [];
    /**
     * The table gets rendered twice in the first time as if it is server side.
     * First it gets rendered when creating the table and then again
     * when the rows are measured for the paginator.
     * Use this flag to interrupt the renderization of the table for the
     * first time.
     */
    private firstTime: boolean = true;
    public scrollPosition: ScrollPosition;

    constructor(
        model: TableModel,
        url: string,
        filterData: any) {
        this.model = model;
        this.url = url;
    }

    public reset(): void {
        this.model.empty();
    }

    public paginate = (request: DataTables.AjaxDataRequest, callback, settings) => {
        let requestWithSorting = this.prepareSorting(request);

        if (JSON.stringify(this.currentSorting) !== JSON.stringify(requestWithSorting.order)) {
            this.model.empty();
        }
        let adjustedRequest = this.prepareRange(requestWithSorting);

        if (adjustedRequest.length === 0) {
            return this.preparePage(request, this.model.recordsTotal, callback);
        }
        let serverRequest = { ...this.model.getFilterData() };
        delete serverRequest["_parent_"];
        serverRequest["pagination"] = adjustedRequest;
        this.currentSorting = requestWithSorting.order;
        let url = this.urlForFetch(serverRequest);
        S6Request.url(url).reauthenticate().get().res((d) => {
            d.bundle.data.recordsFiltered = d.bundle.data.recordsTotal;
            this.fillModel(adjustedRequest, d.bundle.data);
            this.model.recordsTotal = d.bundle.data.recordsTotal;
            this.model.footer = d.bundle.data.footer;

            return this.preparePage(request, this.model.recordsTotal, callback);
        });
    }

    private urlForFetch(request: AjaxDataRequest): string {
        let params = queryString.stringify(request);
        return sislogUserGlobals.appendUrlParams(this.url + "?" + params);
    }

    private prepareSorting(request: DataTables.AjaxDataRequest): AjaxDataRequest {
        let adjustedRequest: AjaxDataRequest = {
            draw: request.draw,
            start: request.start,
            length: request.length,
            order: [],
        };
        for (let o of request.order) {
            adjustedRequest.order.push({
                column: request.columns[o.column].name,
                dir: o.dir,
            });
        }
        return adjustedRequest;
    }

    private preparePage(request: DataTables.AjaxDataRequest, recordsTotal: number, callback) {
        if (this.firstTime) {
            this.firstTime = false;
            return;
        }
        let page = {
            draw: request.draw,
            recordsTotal,
            recordsFiltered: recordsTotal,
            data: this.model.getRows(request.start, request.start + request.length),
        };
        return callback(page);

    }

    private prepareRange(request: AjaxDataRequest): AjaxDataRequest {
        if (this.firstTime) {
            request.length = 180;
        }
        let adjustedRequest = Object.assign({}, request);
        let start = request.start;
        let end = request.start + request.length;
        adjustedRequest.start = this.model.findFirstMissing(start, end);
        adjustedRequest.length = this.model.findLastMissingLength(start, request.length);

        return adjustedRequest;
    }

    private fillModel(request: AjaxDataRequest, data: TableData) {
        let start = request.start;
        for (let i = 0; i < data.data.length; i++) {
            if (this.model.getRow(start + i) == null) {
                this.model.setRow(start + i, data.data[i]);
            }
        }
    }

    public getCurrentSorting() {
        return this.currentSorting;
    }
}

interface AjaxDataRequest {
    draw: number;
    start: number;
    length: number;
    order: AjaxDataRequestOrder[];
}
export interface AjaxDataRequestOrder {
    column: string;
    dir: string;
}
